import { motion } from "framer-motion";

export const BookList = ({ books, selectedBook, onSelectBook }) => {
  return (
    <div className="w-1/3 border-r border-border overflow-y-auto p-4" data-testid="books-list">
      {books.length === 0 ? (
        <p className="text-muted-foreground text-center py-8">No books yet. Create your first spiritual book!</p>
      ) : (
        books.map((book) => (
          <motion.div
            key={book.id}
            onClick={() => onSelectBook(book)}
            className={`p-4 mb-2 border cursor-pointer transition-all ${
              selectedBook?.id === book.id
                ? "border-white bg-secondary"
                : "border-border hover:border-white/40"
            }`}
            data-testid={`book-item-${book.id}`}
          >
            <h3 className="font-semibold">{book.title}</h3>
            <p className="text-sm text-muted-foreground">by {book.author}</p>
            <p className="text-xs text-muted-foreground mt-1">{book.chapters?.length || 0} chapters</p>
          </motion.div>
        ))
      )}
    </div>
  );
};
